<template>
  <div class="warehouse-list">
    <div class="good-warehouse-title">
      <p class="pre-title">好仓推荐</p>
      <img src="@/assets/img/lable_best.png" />
    </div>
    <div class="warehouse-detail">
      <div
        v-for="item in list"
        :key="item.id"
        @click="toDetail(item.id)"
      >
        <div class="img-box">
          <img :src="wareImage(item.files) ? wareImage(item.files) : require('@/assets/img/pic-cangku-default.png')" />
        </div>
        <div class="warehouse-item">
          <p class="warehouse-name">{{item.warehouseSourceName}}</p>
          <p class="warehouse-area">可租面积: {{item.availableArea}}㎡</p>
          <!-- <div >
            <p v-if="item.isShowChargeInfo">
              <span class="price-amount">{{item.min}}</span>{{item.minUnit || ''}}起
            </p>
            <span v-else class="price">
              价格请电话联系
            </span>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getEntrepotInfo } from '@/api/seekWarehouse/seekWarehouse'

export default {
  name: 'Recommend',
  props:{
  },
  data() {
    return {
      list: [],
    }
  },
  computed: {
    wareImage() {
      return function getImage(file) {
        let img
        const res = [...file].filter((v) => v.fileType.startsWith('image'))
        if (res[0]) {
          img = res[0].filePath
        }
        return img
      }
    }
  },
  async created() {
    // 获取列表，用于展示好仓推荐
    const res = await getEntrepotInfo({
      isRecommend: true
    }, {
      page: 1,
      size: 10
    })
    res.records.map(info => {
      const item = info
      let min = 0;
      let minUnit = '';
      (item.chargeInfos || []).forEach(charge => {
        if (!min || min > charge.price) {
          min = charge.price
          minUnit = charge.unit
        }
      })
      item.min = min
      item.minUnit = minUnit
      return item
    })
    this.list = res.records || []
  },
  methods: {
    toDetail(id) {
      this.$emit('toDetail', `${id}`)
    }
  }
}
</script>

<style lang="less" scoped>
.warehouse-list {
  background: #fff;
  // padding-top: 32px;
  border-radius: 6px;
  max-height: 100%;
  overflow-y: auto;
  .good-warehouse-title {
    background: #fff;
    padding: 24px 0 16px;
    top: 0;
    position: sticky;
    display: flex;
    align-items: baseline;
    .pre-title {
      font-size: 18px;
      color: #171717;
      font-weight: bold;
      display: flex;
      align-items: center;
      &::before {
        content: '';
        width: 4px;
        height: 16px;
        display: block;
        background: #06b880;
        border-radius: 2px;
        margin-right: 28px;
      }
    }
    img {
      width: 24px;
      height: 24px;
      margin-left: 8px;
    }
  }
  .warehouse-detail {
    padding: 0 32px;
    > div {
      cursor: pointer;
    }
  }
  .img-box {
    border-radius: 8px;
    overflow: hidden;
    img {
      width: 100%;
    }
  }
  .warehouse-item {
    margin: 16px 0 32px 0;
    color: #909399;
    .warehouse-name {
      color: #171717;
      overflow: hidden;
      text-overflow: ellipsis;
      word-break: break-all;
      white-space: nowrap;
    }
    .warehouse-area {
      margin: 2px 0;
    }
    .price-amount {
      color: #ED4934;
      font-size: 17px;
      font-weight: bold;
    }
    .price {
      color: #ED4934;
    }
  }
}
</style>